import { type RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    name: 'home',
    path: '/',
    component: () => import('@pages/home/page/HomePage.vue')
  },
  {
    name: 'privacy-policy',
    path: '/privacy-policy',
    component: () => import('@pages/legal/privacy-policy/PrivacyPolicyPage.vue')
  },
  {
    name: 'cookie-policy',
    path: '/cookie-policy',
    component: () => import('@pages/legal/cookie-policy/CookiePolicyPage.vue')
  },
  {
    name: 'terms',
    path: '/terms',
    component: () => import('@pages/legal/terms/TermsPage.vue')
  },
  {
    name: 'not-found',
    path: '/:pathMatch(.*)*',
    redirect: { name: 'home' }
  }
]

export default routes
